
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { BackButton } from "@/components/ui/back-button";
import PromptLibrary from "@/components/PromptLibrary";
import { HowToWorkWithMe } from "@/components/HowToWorkWithMe";
import { LetsConnect } from "@/components/soundboard-sessions/LetsConnect";

const SoftSkillsAIEra = () => {
  const navigate = useNavigate();

  const additionalServices = [
    {
      title: "Coaching",
      icon: <Plus className="w-10 h-10" />,
      items: [
        {
          label: "1:1 Co-pilot and Coaching",
          route: "/copilot-coaching"
        }
      ]
    },
    {
      title: "Fractional leader",
      icon: <Plus className="w-10 h-10" />,
      items: [
        {
          label: "Fractional Product and Content Leadership",
          route: "/fractional-leadership"
        }
      ]
    }
  ];

  return (
    <main className="min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 pt-8">
        <BackButton />
      </div>
      <PromptLibrary />
      <div className="max-w-6xl mx-auto px-4">
        <LetsConnect />
      </div>
      <HowToWorkWithMe services={additionalServices} />
    </main>
  );
};

export default SoftSkillsAIEra;
